export default "images/background-image.png";